import { MAX_DRAFT_TRANSCRIPT_LENGTH } from '@/shared/types/simulation-draft';

import type { ConversationTurn } from '../types/conversation';

// A single exchange yields a scenario that restates the opening message.
const MIN_TURNS_FOR_DRAFT = 2;

const CUSTOMER = 'Customer';
const AGENT = 'AI agent';

const ELISION = '\n[...]\n';

const requestText = (turn: ConversationTurn): string => turn.request?.text?.trim() ?? '';

const responseText = (turn: ConversationTurn): string =>
  turn.responses
    .filter((response) => response.type === 'text')
    .map((response) => response.text.trim())
    .filter(Boolean)
    .join('\n');

const countCustomerTurns = (turns: ConversationTurn[]): number =>
  turns.filter((turn) => !turn.pending && requestText(turn)).length;

const elideMiddle = (text: string): string => {
  if (text.length <= MAX_DRAFT_TRANSCRIPT_LENGTH) {
    return text;
  }
  const budget = MAX_DRAFT_TRANSCRIPT_LENGTH - ELISION.length;
  const head = Math.floor(budget * 0.4);
  return `${text.slice(0, head)}${ELISION}${text.slice(text.length - (budget - head))}`;
};

export const transcriptForDraft = (turns: ConversationTurn[]): string => {
  if (countCustomerTurns(turns) < MIN_TURNS_FOR_DRAFT) {
    return '';
  }
  const lines: string[] = [];
  for (const turn of turns) {
    if (turn.pending) {
      continue;
    }
    const request = requestText(turn);
    if (request) {
      lines.push(`${CUSTOMER}: ${request}`);
    }
    const response = responseText(turn);
    if (response) {
      lines.push(`${AGENT}: ${response}`);
    }
  }
  return elideMiddle(lines.join('\n'));
};
